export default "__VITE_ASSET__CpVpuXqN__"